export const SUPPORT_EMAIL = "support@sharpperformance.com";
